import IconButton, {
  Button,
} from 'components/Common/MasterComponents/Buttons/IconButton'
import { FC, PropsWithChildren } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: contents;
  ${Button} {
    height: 100%;
    border: none;

    &:hover {
      background-color: var(--color-g-3);
    }
  }
`

interface MoveSlideButtonProps {
  onClick: () => void
}

const MoveSlideButton: FC<PropsWithChildren<MoveSlideButtonProps>> = ({
  onClick,
  children,
}) => {
  return (
    <Wrapper>
      <IconButton onClick={onClick} type='secondary' size='L'>
        {children}
      </IconButton>
    </Wrapper>
  )
}

export default MoveSlideButton
